import { UsersData, UsersState } from '@/types/User';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: UsersState = {
  usersData: { totalPages: 0, page: 1, data: null, searchText: '', filterValue: 0, sortKey: 'id', sortDirection: 'desc' },
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsersData: (state, action: PayloadAction<UsersData>) => {
      state.usersData = action.payload;
    },
    setUsersPageAction: (state, action: PayloadAction<number>) => {
      state.usersData.page = action.payload;
    },
    archiveUserAction: (state, action: PayloadAction<number>) => {
      if (state.usersData.data) {
        state.usersData.data = state.usersData.data.filter(user => user.id !== action.payload);
      }
    },
    setUserSearchTextAction: (state, action: PayloadAction<string>) => {
      state.usersData.searchText = action.payload;
      state.usersData.page = 1;
    },
    setUserFilterValueAction: (state, action: PayloadAction<number>) => {
      state.usersData.filterValue = action.payload;
    },
    setUsersSortAction: (state, action: PayloadAction<{ sortKey: string; sortDirection: 'asc' | 'desc' }>) => {
      state.usersData.sortKey = action.payload.sortKey;
      state.usersData.sortDirection = action.payload.sortDirection;
    },
    clearUsersStateAction: () => initialState,
  },
});

export const {
  setUsersData,
  archiveUserAction,
  setUsersPageAction,
  setUserSearchTextAction,
  clearUsersStateAction,
  setUserFilterValueAction,
  setUsersSortAction,
} = usersSlice.actions;

export default usersSlice.reducer;
